import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"sortable-header d-flex",on:{"click":_vm.toggleSort,"mouseover":_vm.toggleHover,"mouseout":_vm.toggleHover}},[_c('div',{staticClass:"align-self-center subtitle-2"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"align-self-center icon-container"},[_c(VIcon,{attrs:{"medium":"","color":!_vm.show ? 'grey lighten-1' : ''}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }